import { render, staticRenderFns } from "./SignItemsList.vue?vue&type=template&id=59203350&scoped=true&"
import script from "./SignItemsList.vue?vue&type=script&lang=js&"
export * from "./SignItemsList.vue?vue&type=script&lang=js&"
import style0 from "./SignItemsList.vue?vue&type=style&index=0&id=59203350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59203350",
  null
  
)

export default component.exports